export default __webpack_public_path__ + "8e1b096dd974a0e1adfd6149dfc38ad8.png";